import { INFINITE_DAY } from '@/configuration/general';

export default function getLiaisonTarifADate(produit, produitId, datePivot) {
  if (!produit.liaisonsTarif) return null;
  const result = produit.liaisonsTarif.filter((ligne) => {
    const dateFinLiaison = ligne.dateFin ? new Date(ligne.dateFin) : INFINITE_DAY;
    return new Date(ligne.dateDebut) <= datePivot
      && dateFinLiaison >= datePivot;
  });
  if (result.length === 0) {
    return null;
  }
  let ligne = result[0];
  const find = result.find((ligne) => ligne.produitEnfantId === produitId);
  if (find) ligne = find;
  return ligne;
}



// WEBPACK FOOTER //
// ./src/services/catalogue/getLiaisonTarifADate.js